import React from 'react';
import { Form, Row, Col, Button } from 'react-bootstrap';

import useFileUpload from 'hooks/useFileUpload';
import FileUploader from 'components/common/FileUploader';

const ShelfEditForm = ({ shelf, onSubmit, onCancel, isLoading }) => {
  const {
    file,
    initialFile,
    getRootProps,
    getInputProps,
    resetFile,
    clearState,
    isRemoved,
    hasChanged,
  } = useFileUpload({ initialFile: shelf?.location_image });

  const handleSubmit = e => {
    e.preventDefault();

    const imageState = {
      file,
      isRemoved,
      hasChanged,
    };

    onSubmit(e, imageState);
  };

  const handleCancel = () => {
    clearState();
    onCancel();
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control type="text" name="name" defaultValue={shelf?.name} />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Status</Form.Label>
            <Form.Select
              name="is_active"
              defaultValue={shelf?.is_active.toString()}
            >
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Priority</Form.Label>
            <Form.Control
              type="number"
              name="priority"
              defaultValue={shelf?.priority ?? 0}
            />
            <Form.Text className="text-muted">
              * Batch picking walk order. Higher priority shelves are visited
              first.
            </Form.Text>
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="description"
              defaultValue={shelf?.description}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Location Image</Form.Label>
            <FileUploader
              file={file}
              initialFile={initialFile}
              getRootProps={getRootProps}
              getInputProps={getInputProps}
              resetFile={resetFile}
              isRemoved={isRemoved}
            />
          </Form.Group>
        </Col>
      </Row>

      <div className="d-flex justify-content-end gap-2 mt-4">
        <Button variant="secondary" onClick={handleCancel}>
          Cancel
        </Button>
        <Button type="submit" variant="success" disabled={isLoading}>
          {isLoading ? 'Saving...' : 'Save Changes'}
        </Button>
      </div>
    </Form>
  );
};

export default ShelfEditForm;
